import { TextArea, Button, Layer } from '@carbon/react';
import styles from './edit-notes.module.scss';
import commonStyles from './common.module.scss';
import { Edit } from '@carbon/react/icons';
import { useScenarioForm } from './contexts';

interface EditNotesProps {
  editNote: boolean;
  setEditNote: (editNote: boolean) => void;
}

export const EditNotes = ({ editNote, setEditNote }: EditNotesProps) => {
  const { form } = useScenarioForm();

  const handleCancel = () => {
    setEditNote(false);
  };

  return (
    <form.Subscribe selector={(state) => state.values.globalConfig}>
      {(globalConfig) => (
        <div className={commonStyles.configFormContainer}>
          <div className={styles.gridContainer}>
            <div className={styles.contentContainer}>
              <h2 className={commonStyles.configFormTitle}>Notes</h2>

              {!editNote && (
                <p className={styles.notesText}>
                  {globalConfig?.notes || '--'}
                </p>
              )}

              {editNote && (
                <>
                  <form.Field name="globalConfig.notes">
                    {(field) => (
                      <Layer>
                        <TextArea
                          id="notes-textarea"
                          labelText=""
                          placeholder="Add or edit notes..."
                          rows={4}
                          value={field.state.value || ''}
                          onChange={(e) => field.handleChange(e.target.value)}
                        />
                      </Layer>
                    )}
                  </form.Field>
                </>
              )}

              {editNote && (
                <div className={styles.notesActions}>
                  <Button kind="secondary" size="sm" onClick={handleCancel}>
                    Cancel
                  </Button>
                </div>
              )}
            </div>

            {!editNote && (
              <div className={styles.actionContainer}>
                <Button
                  className={styles.editButton}
                  kind="ghost"
                  size="sm"
                  renderIcon={Edit}
                  iconDescription="Edit notes"
                  onClick={() => setEditNote(!editNote)}
                >
                  Edit
                </Button>

                {globalConfig?.createdBy && (
                  <div>
                    <p className={styles.createdByLabel}>Created By</p>
                    <p className={styles.createdByValue}>
                      {globalConfig.createdBy}
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </form.Subscribe>
  );
};
